import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { LatestResult } from "@dimensional-engineering/dimensional-models";
import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore";

export interface LatestResultsSlice {
  latestResults: LatestResult[];
  lastResultPulled: QueryDocumentSnapshot<DocumentData> | null;
  latestResultsLoaded: boolean;
}

const initialState: LatestResultsSlice = {
  latestResults: [],
  lastResultPulled: null,
  latestResultsLoaded: false,
};

export const latestResultSlice = createSlice({
  name: "feed",
  initialState: initialState,
  reducers: {
    setLatestResults: (state, action: PayloadAction<LatestResult[]>) => {
      return { ...state, latestResults: action.payload };
    },
    updateLastResultPulled: (
      state,
      action: PayloadAction<QueryDocumentSnapshot<DocumentData>>
    ) => {
      return { ...state, lastResultPulled: action.payload };
    },
    paginateLatestResult: (state, action: PayloadAction<LatestResult>) => {
      return {
        ...state,
        latestResults: [...state.latestResults, action.payload],
      };
    },
    setLatestResultsLoaded: (state, action: PayloadAction<boolean>) => {
      return { ...state, latestResultsLoaded: action.payload };
    },
  },
});

export const {
  setLatestResults,
  updateLastResultPulled,
  paginateLatestResult,
  setLatestResultsLoaded,
} = latestResultSlice.actions;

export default latestResultSlice.reducer;
